import { getAuth } from "firebase/auth";
export function getActiveParkingId() {
  const user = getAuth().currentUser;
  const id = user?.displayName;
  // The client cannot authorize a tenant! Firestore rules must additionally
  // tie authenticated uid/email/claims to this tenant.
  if (!id || !/^[a-zA-Z0-9_-]{1,128}$/.test(id)) {
    throw new Error("Хэрэглэгчийн зогсоолын эрх тодорхойгүй байна.");
  }
  return id;
}
